import RequestsSwiper from './requests-swiper';

export default RequestsSwiper;
